function logoSlider() {
   var sliders = document.getElementById('logo-list');
   if (sliders) {
      var flkty = new Flickity(sliders, {
         wrapAround: true,
         fullscreen: true,
        autoPlay: true,
         contain: true,
          pageDots: false,
        prevNextButtons: false,
      });
      sliders.classList.add('spring-slider-visible');
   }
}
logoSlider();


function LayoutSlider() {
   var slidersLayout = document.getElementById('layout-slider');
   if (slidersLayout) {
      var flkty = new Flickity(slidersLayout, {
         wrapAround: true,
         fullscreen: true,
        autoPlay: true,
         contain: true,
      pageDots: false,
      });
      slidersLayout.classList.add('spring-slider-visible');
   }
}
LayoutSlider();

function reviewSliders() {
   var slidersreview = document.getElementById('custom-reviews-slider');
   if (slidersreview) {
      var flkty = new Flickity(slidersreview, {
         wrapAround: true,
         fullscreen: true,
         contain: true,
         pageDots: false
      });
      slidersreview.classList.add('spring-slider-visible');
   }
}
reviewSliders();


function reviewBSliders() {
   var slidersreviewB = document.getElementById('custom-reviews-sliderB');
   if (slidersreviewB) {
      var flkty = new Flickity(slidersreviewB, {
         wrapAround: true,
         fullscreen: true,
         contain: true,
         pageDots: false,
        cellAlign: 'left'
      });
      slidersreviewB.classList.add('spring-slider-visible');
   }
}
reviewBSliders();

function imageSliders() {
   var sliderimage = document.getElementById('image-txt-slider');
   if (sliderimage) {
      var flkty = new Flickity(sliderimage, {
         wrapAround: true,
         fullscreen: true,
         contain: true,
      });
      sliderimage.classList.add('spring-slider-visible');
   }
}
imageSliders();


function collectionSliders() {
   var slidercollection = document.getElementById('collection-sliders');
   if (slidercollection) {
      var flkty = new Flickity(slidercollection, {
         wrapAround: true,
         fullscreen: true,
         contain: true,
      });
      slidercollection.classList.add('spring-slider-visible');
   }
}
collectionSliders();